import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Tabs, Tab, Card, Col, Button, Alert, Container, Badge} from 'react-bootstrap';
import Loader from '../components/Loader';
import _ from 'lodash'
import * as errorActionCreators from '../redux/actions/error';
import api from '../helpers/apiClient';
import moment from 'moment';
import VendorSelection from '../components/VendorSelection'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid, regular, brands } from '@fortawesome/fontawesome-svg-core/import.macro'
import { Form } from 'react-bootstrap';
import TabHeader from '../components/TabHeader';
import Dropzone from 'react-dropzone'
import uploadIcon from '../images/upload-icon.svg'

const { SearchBar } = Search;

const country = window.location.hostname === 'seller.giftr.my' ? 'MY' : 'SG'
const oppositeGiftrDomain = window.location.hostname === 'seller.giftr.my' ? 'giftr.sg' : 'giftr.my'
const currency = window.location.hostname === 'seller.giftr.my' ? 'RM' : 'S$'

class AxisImport extends Component {
  constructor(props) {
    super(props);
    const { location, user } = props;

    this.pastedTableRef = React.createRef();

    this.state = {
      loading: false,
      items: [],
      selectedIds: [],
      successMessage: 'Product(s) imported successfully',
      importing: false,
      error: "",
      file: null,
      pastedTableHtml: '',
      page: 1
    }
  }

  async componentDidMount() {
    const { user } = this.props;

    const isAdmin = user.role === 'admin' || user.role === 'staff'
  }

  handleOnChange = (e) => {

    this.setState({ [e.target.name]: e.target.value })
  }

  renderDate = (cell, row) => {

    return cell ? moment(cell).format("DD/MM/YYYY") : ''
  }

  renderPrice = (cell, row) => {
      return  `${parseInt(cell).toFixed(2)}` 
  }

  isPending = (cell) => {
    const { products, provider } = this.state

    //filter products where id start with "P"
    let pendingProduct = _.filter(products, product => {
      return product.id.toString().startsWith('P')
    })

    //remove underscore from provider
    const providerName = provider.replace('_', '')

    //find product in products where tags contains "sync_{provider}_{cell}"
    const match = _.filter(pendingProduct, product => {
      return _.includes(product.tags, `sync_${providerName}_${cell}`)
    })

    return match
  }

  isMatchedName = (row) => {

    const { products } = this.state

    //find product in products where name matches row.name
    const matchName = _.filter(products, product => {
      let productTitle = _.toLower(_.trim(product.title, '0123456789 '))
      let rowTitle = _.toLower(_.trim(row.title, '0123456789 '))

      return _.includes(productTitle, rowTitle) || _.includes(rowTitle, productTitle)
    })

    return matchName

  }

  renderSynced = (cell, row) => {

    let matched = this.isSynced(cell)
    let matchedName = this.isMatchedName(row)
    let isPending = this.isPending(cell)

    //if match display synced
    if(matched && matched.length > 0){
      //render badge synced
      return <Badge bg="success">Linked</Badge>
    }

    if(isPending && isPending.length > 0){
      //render badge synced
      return <Badge bg="warning">Pending</Badge>
    }

    if(matchedName && matchedName.length > 0){
      //render badge synced
      return <Badge bg="warning">Matched</Badge>
    }

    return <Badge bg="danger">Unlinked</Badge>
  }

  renderExpandedComponent = (row) => {

    return (
      <div>
        <p>{row.body}</p>
      </div>
    )
  }

  handleOnDrop = (files) => {
    if(files && files.length > 0){
      this.setState({
        uploadingFile: true
      });

      var formData = new FormData();
      formData.append('po', files[0]);

      api('/axis/po/read' , {
        method: 'POST',
        body: formData
      }, {'Accept': 'application/json'}).then(data => {
        this.setState({
          uploadingFile: false,
          items: data,
          importType: "csv",
          file: files[0]
        });
      }).catch(err =>{
        this.setState({
          uploadingFile: false
        });
        console.log(err)
      })
    }
  }

  normalizePastedValue = (value) => {
    return _.trim((value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' '))
  }

  parsePastedNumber = (value) => {
    const normalizedValue = this.normalizePastedValue(value)

    if(!normalizedValue || normalizedValue === '-'){
      return null
    }

    const parsedValue = Number(normalizedValue.replace(/,/g, ''))
    return Number.isFinite(parsedValue) ? parsedValue : null
  }

  getPastedHeaderKey = (header) => {
    const normalizedHeader = _.toLower(this.normalizePastedValue(header))
      .replace(/&nbsp;/g, ' ')
      .replace(/[^a-z0-9()%]+/g, ' ')

    if(normalizedHeader.includes('axis po number')) return 'axisPONumber'
    if(normalizedHeader.includes('product sku')) return 'productSKU'
    if(normalizedHeader.includes('quantity')) return 'totalQuantity'
    if(normalizedHeader.includes('denomination')) return 'denomination'
    if(normalizedHeader.includes('order value')) return 'orderValue'
    if(normalizedHeader.includes('handling fee')) return 'handlingFee'
    if(normalizedHeader.includes('total amount')) return 'totalAmount'
    if(normalizedHeader.includes('order date')) return 'orderDate'
    if(normalizedHeader.includes('brand')) return 'brand'

    return null
  }

  getPastedTableSource = (rawHtml) => {
    const { pastedTableHtml } = this.state
    const htmlSource = rawHtml !== undefined ? rawHtml : pastedTableHtml

    if(!htmlSource){
      return ''
    }

    if(/<table[\s>]/i.test(htmlSource)){
      return htmlSource
    }

    const container = document.createElement('div')
    container.innerHTML = htmlSource
    const decodedText = this.normalizePastedValue(container.textContent)

    if(/<table[\s>]/i.test(decodedText)){
      return decodedText
    }

    return htmlSource
  }

  handlePastedTableInput = (e) => {
    this.setState({
      pastedTableHtml: e.currentTarget.innerHTML,
      error: ''
    })
  }

  handlePastedTableBlur = (e) => {
    const html = e.currentTarget.innerHTML
    const hasContent = this.normalizePastedValue(e.currentTarget.textContent)

    this.setState({
      pastedTableHtml: html,
      error: ''
    }, () => {
      if(hasContent){
        this.handleParsePastedTable(html)
      }
    })
  }

  handleClearPastedTable = () => {
    if(this.pastedTableRef.current){
      this.pastedTableRef.current.innerHTML = ''
    }

    this.setState((prevState) => ({
      pastedTableHtml: '',
      error: '',
      items: prevState.importType === 'html' ? [] : prevState.items,
      importType: prevState.importType === 'html' ? null : prevState.importType
    }))
  }

  handleParsePastedTable = (rawHtml) => {
    const tableSource = this.getPastedTableSource(rawHtml)

    if(!tableSource){
      this.setState({
        error: 'Paste an HTML table before parsing.'
      })
      return
    }

    const parser = new DOMParser()
    const documentNode = parser.parseFromString(tableSource, 'text/html')
    const table = documentNode.querySelector('table')

    if(!table){
      this.setState({
        error: 'No HTML table was found in the pasted content.'
      })
      return
    }

    const rows = Array.from(table.querySelectorAll('tr'))

    if(rows.length < 2){
      this.setState({
        error: 'The pasted table must include a header row and at least one data row.'
      })
      return
    }

    const headers = Array.from(rows[0].querySelectorAll('th, td')).map((cell) => this.getPastedHeaderKey(cell.textContent))

    if(!headers.includes('axisPONumber') || !headers.includes('productSKU')){
      this.setState({
        error: 'The pasted table must include Axis PO Number and Product SKU columns.'
      })
      return
    }

    const items = rows.slice(1).map((row, index) => {
      const cells = Array.from(row.querySelectorAll('td, th'))

      return cells.reduce((item, cell, cellIndex) => {
        const headerKey = headers[cellIndex]

        if(!headerKey){
          return item
        }

        const cellValue = this.normalizePastedValue(cell.textContent)

        if(['totalQuantity', 'denomination', 'orderValue', 'handlingFee', 'totalAmount'].includes(headerKey)){
          item[headerKey] = this.parsePastedNumber(cellValue)
          return item
        }

        if(headerKey === 'axisPONumber'){
          //get last 8 characters if cellValue length is more than 8
          let date = cellValue.length > 8 ? cellValue.slice(-8) : cellValue
          const parsedDate = moment(date, ['YYYYMMDD'], true)
          if(parsedDate.isValid()){
            //parseDate + 1 day
            parsedDate.add(1, 'day')
            item.orderDate = parsedDate.toDate()
          }
        }

        //if productSKU contains "TOUCHNGO" or "SWITCH" set brand to "Touch 'n Go" or "Switch"
        if(headerKey === 'productSKU'){
          if(cellValue.toUpperCase().includes('TOUCHNGO')){
            item.brand = "Touch N Go"
          } else if(cellValue.toUpperCase().includes('SWITCH')){
            item.brand = "Switch"
          }
        }

        item[headerKey] = cellValue
        return item
      }, {
        id: `html-${index}`,
      })
    }).filter((item) => {
      return item.axisPONumber && item.productSKU && item.productSKU !== '0' && item.totalQuantity !== null
    })

    console.log('Parsed items from pasted table:', items)

    if(items.length < 1){
      this.setState({
        error: 'No valid PO rows were found in the pasted table.',
        items: [],
        importType: null
      })
      return
    }

    this.setState({
      items,
      importType: 'html',
      file: null,
      error: ''
    })
  }

  handleImportPO = async () => {
    const { items } = this.state;

    this.setState({
      importing: true
    });

    api('/axis/po/import', {
      method: 'POST',
      body: JSON.stringify({po: items})
    }).then(data => {
      this.setState({
        importing: false,
        items: [],
        displayProductImportAlert: true,
        productImportSuccess: true
      });
    }).catch(err =>{
      this.setState({
        importing: false,
        displayProductImportAlert: true,
        productImportSuccess: false
      });
      console.log(err)
    })
  }

  handlePageChange = async (e) => {    
    let page = e.target.value
    this.setState({ page })
  }

  handleDismissAlert = () => {
    this.setState({
      displayProductImportAlert: false
    })
  }

  render() {
    const { user, match } = this.props;
    const { items, selectedIds, loading, displayProductImportAlert, successMessage,
      password, storeUrl, vendorList, importing, error, productImportSuccess, preselectedId, 
      file, importType, showProductEditModal, selectOptions, pastedTableHtml,
      pendingProducts, page } = this.state;

    const isAdmin = user.role === 'admin' || user.role === 'staff'

    const options = {
      showTotal: true,
      sizePerPage: 20,
      sizePerPageList: [{
        text: '10', value: 10
      }, {
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }, {
        text: 'All', value: items.length
      }],
    };
    
    const columns = [
      {
        dataField: 'orderDate',
        text: 'Order Date',
        sort: true,
        formatter: this.renderDate,
        headerStyle: {
          width: '100px',
          resize: 'horizontal'
        },
      },
      {
        dataField: 'axisPONumber',
        text: 'Axis PO Number',
        headerStyle: {
          width: '150px',
          resize: 'horizontal'
        },
      },
      {
        dataField: 'brand',
        text: 'Brand',
        sort: true,
        headerStyle: {
          width: '120px',
          resize: 'horizontal'
        },
      },
      {
        dataField: 'productSKU',
        text: 'Product SKU',
        headerStyle: {
          width: '180px',
          resize: 'horizontal'
        },
      },
      {
        dataField: 'totalQuantity',
        text: 'Quantity',
        headerStyle: {
          width: '80px',
          resize: 'horizontal'
        }
      },
      {
        dataField: 'denomination',
        text: 'Denomination (RM)',
        formatter: this.renderPrice,
        headerStyle: {
          width: '80px',
          resize: 'horizontal'
        }
      },
      {
        dataField: 'orderValue',
        text: 'Order Value',
        formatter: this.renderPrice,
        headerStyle: {
          width: '80px',
          resize: 'horizontal'
        }
      }
    ];

    return (
      <div>
        <TabHeader title="Import Axis Rewards PO" tab_id="import_products" user={user} />
        <div className="row mt-3 mb-4 justify-content-between g-3">
            <Col xs={12} lg={12}>
              <Card className="shadow-sm" style={{border: 'none', borderRadius:'10px'}}>
                <Card.Header className="my-2 mx-4 px-0" style={{background: '#fff',}}>
                  <h5 className="mb-0">Import PO by Excel Sheet</h5>
                </Card.Header>
                <Card.Body className="grey-label label-strong mx-3">
                  <div>
                    <label>Attach a .xlsx file.</label>
                    <Dropzone
                      className='dropzone-area'
                      onDrop={this.handleOnDrop}
                      multiple={false}
                      accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'>
                      <div className="dropzone-text">
                        <img src={uploadIcon} style={{ width: '30px', margin: '0 10px' }}></img>
                        <span>Drag and drop files here, or click to upload</span>
                      </div>
                    </Dropzone><br />
                    { 
                      file &&
                      <label className="my-auto">Current file: {file.name}</label>
                    }
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} lg={12}>
              <Card className="shadow-sm h-100" style={{border: 'none', borderRadius:'10px'}}>
                <Card.Header className="my-2 mx-4 px-0" style={{background: '#fff'}}>
                  <h5 className="mb-0">Paste HTML Table</h5>
                </Card.Header>
                <Card.Body className="grey-label label-strong mx-3 d-flex flex-column">
                  <div
                    ref={this.pastedTableRef}
                    contentEditable
                    suppressContentEditableWarning
                    className="form-control"
                    onInput={this.handlePastedTableInput}
                    onBlur={this.handlePastedTableBlur}
                    style={{minHeight: '220px', overflow: 'auto'}}
                  />
                  <small className="text-muted mt-2">You can paste directly from email, Excel, or raw HTML source that contains a table.</small>
                  <Container fluid className="px-0 mt-3 d-flex gap-2 flex-wrap">
                    <Col sm="auto" className="px-0">
                      <Button
                        variant="outline-secondary"
                        className="btn-br-6"
                        disabled={!pastedTableHtml}
                        onClick={this.handleClearPastedTable}
                      >Clear</Button>
                    </Col>
                  </Container>
                </Card.Body>
              </Card>
            </Col>
          </div>
        {
          items.length > 0 &&
          <Container fluid className="my-3 d-flex gap-3 flex-column flex-sm-row-reverse flex-wrap">
            <Col sm="auto">
              <Button
                variant="primary"
                className="w-100 btn-br-6"
                disabled={importing || items.length < 1}
                onClick={this.handleImportPO}
              >{ `Import ${items.length} line item${items.length > 1 ? 's' : ''}` }</Button>
            </Col>
          </Container>
        }
        <div>
        {
          error &&
          <span>{error}</span>
        }
        {
          displayProductImportAlert &&
            <div className="sticky-alert" style={{zIndex:'1000'}}>
              <Alert variant={productImportSuccess ? "success" : "danger"} dismissible onClose={this.handleDismissAlert}>
                <span dangerouslySetInnerHTML={{__html: successMessage}}></span>
              </Alert>
            </div>
        }
        {
          loading &&
          <Loader />
        }
        {
          !loading && items.length > 0 &&
          <ToolkitProvider
              keyField='id'
              data={items}
              columns={columns}
              search
            >
              {
                props => (
                  <>
                  <Container fluid className="mb-3 mt-4 d-flex gap-3 flex-row flex-wrap">
                      <Col xs={4}>
                        <SearchBar { ...props.searchProps }
                        style={{borderRadius:'25px'}} placeholder="Search"/>
                      </Col>
                    </Container>

                    <BootstrapTable
                      { ...props.baseProps }
                      bordered={true}
                      pagination={paginationFactory(options)}
                      hover 
                      expandableRow={() => false}
                      expandComponent={this.renderExpandedComponent}
                      options={{
                        expandBy: "column",
                        sizePerPage: 20,
                        paginationShowsTotal: true,
                        sortName: "created_at",
                        sortOrder: "desc"
                      }}
                    />
                </>
            )
          }
          </ToolkitProvider>
        }
        </div>
      </div>
    )
  }
}

const defaultOptions = [];

export default connect((state, props) => {
  return {
    error: state.error,
    user: state.auth.user,
  };
}, {
  ...errorActionCreators,
})(AxisImport);

